class PassStrength extends HTMLElement {
    constructor() {
        super();
        this.obj = null;

        if (this.hasAttribute("linkto")) {
            this.linkTo = this.getAttribute("linkto");
        }

        this.score = -100;
    }

    static get boundAttributes() {
        return ['linkto'];
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        this[attrName] = newValue;
    }

    connectedCallback() {
        this._wrapper = document.createElement('div');
        this._wrapper.style.display = 'inline-block';
        this._wrapper.style.width = '110px';
        this._wrapper.style.height = '10px';
        this._wrapper.style.fontSize = '12pt';

        this._bar = document.createElement('div');
        this._bar.style.display = 'inline-block';
        this._bar.style.border = '1px solid var(--input-border-color)';
        this._bar.style.borderRadius = '2px';
        this._bar.style.height = '100%';
        this._bar.style.width = '30px';

        this._percentage = document.createElement('div');
        this._percentage.style.height = '100%';

        this._bar.appendChild(this._percentage);
        this._wrapper.appendChild(this._bar);

        this._description = document.createElement('div');
        this._description.style.display = 'inline-block';
        this._description.style.marginLeft = '5px';
        this._wrapper.appendChild(this._description);

        this.appendChild(this._wrapper);

        this.render();

        if (this.hasAttribute('linkto')) {
            this.setupHandler(this.getAttribute('linkto'));
        }
    }

    disconnectedCallback() {
        if (this.obj) {
            this.obj.removeEventListener('keyup', this.validatePassword.bind(this));
            this.obj = null;
        }
    }

    get linkTo() {
        return this.getAttribute('linkto');
    }

    set linkTo(input_id) {
        this.setAttribute("linkto", input_id);
        this.setupHandler(input_id);
    }

    setupHandler(input_id) {
        this.obj = document.getElementById(input_id);
        this.obj.addEventListener('keyup', this.validatePassword.bind(this));
    }

    validatePassword(event) {
        const text = event.target.value;

        if (text.length === 0) {
            this.score = -100;
            this.render();
            return;
        }

        let score = 0;

        if (RegExp('[a-z]').test(text)) score++;
        if (RegExp('[A-Z]').test(text)) score++;
        if (RegExp('[0-9]').test(text)) score++;
        if (RegExp('[^a-zA-Z0-9]').test(text)) score++;
        if (text.length < 8) score -= 2;
        if (text.length > 10) score++;

        // Check for disallowed passwords
        if (text.toLowerCase().indexOf('password') > -1) score -= 2;
        if (text.toLowerCase().indexOf('qwerty') > -1) score -= 2;
        if (text.toLowerCase().indexOf('1234') > -1) score--;
        if (text.toLowerCase().indexOf('4321') > -1) score--;
        if (text.toLowerCase().indexOf('5678') > -1) score--;
        if (text.toLowerCase().indexOf('8765') > -1) score--;

        // Check for 3 or more repeated characters
        if (RegExp("(.)\\1{2,}").test(text)) score--;

        this.score = score;

        this.render();
    }

    render() {
        let color = "grey";
        let description = "";
        let percentage = 10;

        if (this.score >= 5) {
            color = "#3dab40";
            description = "Excellent";
            percentage = 100;
        } else if (this.score >= 3) {
            color = "#d2ac23";
            description = "Good";
            percentage = 75;
        } else if (this.score > -100) {
            color="#d04444";
            description = "Poor";
            percentage = 25;
        }

        if (this.score > -100) {
            this._wrapper.style.display = 'inline-block';

            this._percentage.style.backgroundColor = color;
            this._percentage.style.width = percentage + '%';
            this._description.style.color = color;
            this._description.textContent = description;
        } else {
            this._wrapper.style.display = 'none';
        }

    }
}

customElements.define('pass-strength', PassStrength);